import { Component, Input, OnInit } from '@angular/core';
import { OffersStoreService } from "../../../../_shared/services";
import { RouterLink } from '@angular/router';
import { Offers, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder } from '@clr/angular';
import { CurrencyPipe, DatePipe } from "@angular/common";

@Component({
  selector: 'app-project-details-offer',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe
  ],
  templateUrl: './project-details-offer.component.html',
  styleUrl: './project-details-offer.component.sass'
})
export class ProjectDetailsOfferComponent implements OnInit {
  offers: Offers[] = [];
  descSort= ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusText = '';

  projectId: string = '';

  @Input() cid: number = 0;
  @Input() prid: string = '';

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'sent', display: 'Abgeschickt', label: 'alert-info', icon: 'check-circle'},
    { state: 'rejected', display: 'Entgangen', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'confirmed', display: 'Akzeptiert', label: 'alert-success', icon: 'check-circle'}
  ];

  constructor(
      private offss: OffersStoreService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.projectId = this.cid + '.' + this.prid;
    this.loadList();
  }

  createOffer() {
    if (confirm('Wollen Sie ein neues Angebot zu diesem Projekt erstellen?')) {
      this.offss.createOffer(this.projectId)
          .subscribe(data => {
            this.loadList();
          });
    }
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(offerstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === offerstatus)
  };

  getCellStatus(offerstatus: string) {
    const statusline = this.findButtonStatus(offerstatus, this.statusButtons);
    return {
      'statusLabel' : this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(offerstatus: string) {
    return "alert " + this.getCellStatus(offerstatus).statusLabel + " alert-sm";
  }

  loadList() {
    this.offss.getOffers(this.projectId, 0, 'all').subscribe(data => {
      if (!data) {
        return;
      }

      this.offers = data.object;
      // console.table(this.offers);
      this.loading = false;
      this.descSort = ClrDatagridSortOrder.DESC;
    });
  }
}
